import WIDGETS from './widgets';

export default {
  name: 'ny_patient_dashboard',
  widgets: [
    { content: WIDGETS.WELCOME, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 },
    { content: WIDGETS.MEETING_NYN, breakpoints: { xs: 12, md: 12 }, lazy_loading: 0 },
    { content: WIDGETS.COMMUNITY_NYN, breakpoints: { xs: 12, md: 12 }, lazy_loading: 0 },
    { content: WIDGETS.ACTIVITY_NYN, breakpoints: { xs: 12, md: 12 }, lazy_loading: 0 },
    { content: WIDGETS.MYFILES_NYN, breakpoints: { xs: 12, md: 12 }, lazy_loading: 0 },
  ],
};